import { ReportCoreBase } from "./report.core.base"


export class ReportCore extends ReportCoreBase {

}